import React from 'react';
import ButtonComponent from '../../../components/button/ButtonComponent';
import { ServiceStatus } from '../../../../domain/entities/ServiceEntity';

interface ServiceStatusCardProps {
    carPlate: string;
    onRequestPickup: () => Promise<void>;
    status: ServiceStatus;
}

const ParkedStatusCard: React.FC<ServiceStatusCardProps> = ({ carPlate, onRequestPickup, status }) => {
    const [loading, setLoading] = React.useState(false);
    const _handleClick = async () => {
        setLoading(true);
        await onRequestPickup();
        setLoading(false);
    }
    return (
        <div className="row d-flex flex-column-reverse flex-md-row">
            <div className="col-md-6 my-md-5">
                <h1>El estado de tu vehículo</h1>
                <h2>Placa: {carPlate}</h2>
                {status == ServiceStatus.Parked && <p>Tu vehículo está actualmente estacionado y listo para ser entregado cuando lo solicites.</p>}
                {status == ServiceStatus.WaitingForAcceptance && <p>Tu vehículo está esperando la aceptación del valet para iniciar el proceso de entrega.</p>}
                <ButtonComponent 
                    design='secondary' 
                    text="Solicitar Entrega" 
                    onClick={_handleClick}
                    disabled={loading}
                />
            </div>
            <div className="col-md-6 my-5 p-1 d-flex justify-content-center align-items-center" style={{ backgroundColor: "#ffffff44", borderRadius: '8px' }}>
                <img src="/assets/car_parked.png" alt="Vehículo estacionado" />
            </div>
        </div>
    );
};

export default ParkedStatusCard;
